import { createSelector } from 'reselect';

/**
 * getThirdPartyIntegrations
 * Selector for the thirdPartyIntegrations state.
 * @param { Object } state: The application state.
 * @returns { Object } The thirdPartyIntegrationss state.
 */
export const getThirdPartyIntegrations = (state) =>
  state.integrations.thirdPartyIntegrations.thirdPartyIntegrations;

/**
 * selectThirdPartyIntegrations
 * Selects the thirdPartyIntegrations from the thirdPartyIntegrations state.
 * @param { Object } state: The application state.
 * @returns { Any } The value of thirdPartyIntegrations from the thirdPartyIntegrations state.
 */
export const selectThirdPartyIntegrations = createSelector(
  [getThirdPartyIntegrations],
  (thirdPartyIntegrations) =>
    thirdPartyIntegrations.map((thirdPartyIntegration) => {
      const { id, analyticsProvider, enabled, apiToken } = thirdPartyIntegration;
      return {
        ...thirdPartyIntegration,
        filterText: `${id} ${analyticsProvider.toLowerCase()} ${enabled.toString()} ${apiToken.toLowerCase()}`,
      };
    }),
);

export const selectIntegrationToEdit = createSelector(
  [getThirdPartyIntegrations],
  (thirdPartyIntegrations) => (id) =>
    thirdPartyIntegrations.find((integration) => integration.id === id),
);
